import { useState } from 'react';
import { ApiError } from 'requests/RequestBase';
import { GetBulkOrderResData, callDeleteSavedCardApi } from 'requests/RequestPayment';
import { HttpStatus } from 'consts/HttpStatus';
import { ReactError } from 'consts/ReactError';
import { Hr } from 'components/atoms/Hr';
import classes from 'components/templates/override.module.scss';

// 一括共通決済画面の複数カード情報を管理するhook
export const useBulkPaymentCards = (
	Page: any,
	setPage: React.Dispatch<React.SetStateAction<number>>,
	error: string,
	setError: React.Dispatch<React.SetStateAction<string>>,
	order: GetBulkOrderResData,
	displayCardBrandImage: (brand?: string) => JSX.Element,
) => {
	// 保存済みクレジットカード選択値
	const NEW_CARD_SELECT_VALUE = 9999;
	const [selectedCard, setSelectedCard] = useState(0);
	const handleChangeSavedCardSelectValue = async (event: React.ChangeEvent<HTMLInputElement>) => {
		setSelectedCard(Number(event.target.value));
	};
	const isCardSelected = (i: number) => {
		return i === selectedCard;
	};

	const [deleteCardIndex, setDeleteCardIndex] = useState(0);
	const selectDeleteCard = (index: number) => {
		setDeleteCardIndex(index);
		setPage(Page.DELETE_CARD);
	};
	const [deleteCardLoading, setDeleteCardLoading] = useState(false);
	const deleteCard = async () => {
		setDeleteCardLoading(true);
		const result = await callDeleteSavedCardApi(order.payment_tokens[deleteCardIndex].payment_id);
		if (result.status === HttpStatus.GATEWAY_TIMEOUT) {
			setError(ReactError.E0009);
			setDeleteCardLoading(false);
			return;
		}
		if (result.status !== HttpStatus.OK) {
			const errorData = result.data as ApiError;
			setError(errorData.message);
			setDeleteCardLoading(false);
			return;
		}
		setDeleteCardLoading(false);
		order.payment_tokens.splice(deleteCardIndex, 1);
		setSelectedCard(0);
		setPage(Page.DEFAULT);
	};

	const DeleteCardComponent = () => {
		return (
			<>
				{/* カード削除の場合 */}
				<div className="section-head" style={order.logo ? { marginTop: 30 } : { marginTop: 0 }}>
					<span>カード情報の削除</span>
				</div>
				<div className="thankyou-box">
					<img className={classes.thankyouDeleteImage} src="images/delete.svg" alt="削除してよろしいでしょうか" />
				</div>
				<p>
					<div>保存済みのクレジットカード情報を削除します</div>
				</p>
				<Hr />
				{error !== '' && (
					<div className="error-box">
						<div className="error-box-in">
							<p>{error}</p>
						</div>
					</div>
				)}
				<div className={classes.paymentCreditCardInput}>
					<div className="form-box">
						<div className="form-head">
							<label htmlFor="">カード番号 （Card Number）</label>
						</div>
						<div className={`${classes.deleteCardNumber} ${classes.marginLeft20} form-input width50`}>
							{displayCardBrandImage(order.payment_tokens[deleteCardIndex]?.brand)}
							<label htmlFor="">{`**** **** **** ${order.payment_tokens[deleteCardIndex]?.last_digits}`}</label>
						</div>
					</div>
					<div className="form-box">
						<div className="form-head">
							<label htmlFor="">有効期限 （Expiration Date）</label>
						</div>
						<div className={`${classes.marginLeft20} ${classes.paymentCreditExpirationDateRow} form-input width50`}>
							<label htmlFor="">{`${order.payment_tokens[deleteCardIndex]?.expiry.split('-')[1]} / ${
								order.payment_tokens[deleteCardIndex]?.expiry.split('-')[0]
							}`}</label>
						</div>
					</div>
				</div>
				<Hr />
				<div className={classes.sectionPaymentInfoRow}>
					<div className="btn-box">
						<div className="btn wh">
							<button
								onClick={() => {
									setPage(Page.SHOW_SAVED_CARD);
									setError('');
								}}
							>
								戻る
							</button>
						</div>
						<div className="btn gr">
							<button onClick={deleteCard}>削除</button>
						</div>
					</div>
				</div>
			</>
		);
	};

	return {
		NEW_CARD_SELECT_VALUE,
		handleChangeSavedCardSelectValue,
		selectedCard,
		isCardSelected,
		selectDeleteCard,
		deleteCardLoading,
		DeleteCardComponent,
	};
};
